<template>
    <div style="width:100%;">
        <v-image-input
        style="direction:ltr !important"
        clearIcon="fa fa-times"
        errorIcon="fa fa-exclamation-triangle"
        rotateClockwiseIcon="fa fa-redo"
        rotateCounterClockwiseIcon="fa fa-undo"
        flipHorizontallyIcon="fa fa-align-right"
        flipVerticallyIcon="fa fa-align-left"
        successIcon="fa fa-check"
        uploadIcon="fa fa-upload"
        v-model="imageData"
        :image-quality="0.85"
        imageMinScaling="contain"
        clearable
        image-format="jpeg"
        fullHeight
        fullWidth
        overlayBorderWidth="1px"
        />
        <div style="display:flex;justify-content:center">
            <v-btn outlined dark @click="uploadEntityLogo" color="blue"><v-icon small style="padding-left:5px;">fa fa-upload</v-icon>&nbsp; آپلود</v-btn>
        </div>
    </div>
    
</template>
<script>
const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
export default {
    
    name:"imgeditor",
    props:{
        FileLoc:{type:String},
        imageUrl:{type:String},
        UploadUrl:{type:String,default:null}
    },
    data:()=>({
        imageData:"",
        imgUrl:""
    }),
    computed:
    {
        dataUrl:function()
        {
            let vm = this;
            if(vm.imageUrl != "")
            {
                let dataImage = this.toDataURL(vm.imageUrl,function(du){
                    vm.imageData = du;
                });
            }
        }
    },
    watch:{
        dataUrl:function(val)
        {
            alert("Detect");
        }
    },
    methods:{
        async uploadEntityLogo()
        {
            let vm = this;
            if(vm.imageData == "")
            {
                MSGHNDL.ERR("لطفا ابتدا عکس را انتخاب نمایید");
                return;
            }
            let url = "";debugger;
            if(vm.UploadUrl == null || vm.UploadUrl == "")
            {
                url = ApiUrl.registerGalleryChild;
            }
            else
            {
                url = vm.UploadUrl;
            }
            await axios.post(url,{DataUrl:vm.imageData,Loc : vm.FileLoc}).then((res)=>{
                if(res.data.status)
                {
                    MSGHNDL.OK(res.data.msg);
                    vm.imgUrl = res.data.data;
                    vm.EmitData();
                    alert(vm.imgUrl);
                }
                else
                {
                    MSGHNDL.ERR(res.data.msg);
                }
            }).catch((err)=>{console.error(err);});
        },
        EmitData()
        {
            this.$emit("SavedFileName",this.imgUrl);
        },
        toDataURL(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        },
        async getBase64Image(img) 
        {
            alert(img);
           let blob = await fetch(img).then(r => r.blob());
            let dataUrl = await new Promise(resolve => {
            let reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(blob);
            });
            return dataUrl.replace(/^data:image\/(png|jpg);base64,/, "");
        },
        async getImageMimeType(img)
        {
            if (/\.gif$/i.test (img.src) ) {
                return "image/gif";
            } 
            else if (/\.jpg$/i.test (img.src) ) {
                return "image/jpg";
            }
            else if (/\.jpeg$/i.test (img.src) ) {
                return "image/jpeg";
            }
            else if (/\.png$/i.test (img.src) ) {
                return "image/png";
            }
            else {
                return "UNKNOWN";
            }
        }
    }
}
</script>